import React from "react";
import Container from "../../../Components/Container";
import EiaImage from "./assets/BGWithChart@2x.png";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";

const EIA = () => {
  return (
    <Container>
      <BGImageDisplay
        options={{
          objpos: "top",
        }}
        bgimage={EiaImage}
      />
    </Container>
  );
};

export default EIA;
